import { render, staticRenderFns } from "./SlidersSet.vue?vue&type=template&id=3d674b02&scoped=true"
import script from "./SlidersSet.vue?vue&type=script&lang=js"
export * from "./SlidersSet.vue?vue&type=script&lang=js"
import style0 from "./SlidersSet.vue?vue&type=style&index=0&id=3d674b02&prod&lang=scss"
import style1 from "./SlidersSet.vue?vue&type=style&index=1&id=3d674b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d674b02",
  null
  
)

export default component.exports